/**
 * Замечания к «Юниверситету» (16.10.2026, владелец): типы и ручки /api/uni-feedback (routes/uni-feedback.ts).
 * Отправка с ключом request_id: двойное «Отправить» и повтор после обрыва не задвоят замечание.
 */
import { api } from "../../../../api/client";
import { ApiException } from "../../../../api/types";

/** К чему замечание: собирает locate() из места долгого нажатия. */
export interface FbTarget {
  anchor: string; part: string; place: string; quote: string; media: string | null;
}
/** Чей пакет и филиал — знает вкладка, а не DOM (шторки рисуются порталом). */
export interface FbScope { pack: string; version: number | null; branchId: string | null; branchName: string }

export interface FbRow {
  id: number; staff_id: string; staff_name: string | null; pack: string; pack_version: number | null; branch_id: string | null;
  anchor: string; part: string; place: string; quote: string; media: string | null; comment: string;
  status: "new" | "done"; created_at: string; resolved_at: string | null; resolved_by_name: string | null; resolve_note: string | null;
  mine: boolean;
}

export type SendResult = { ok: true; id: number } | { ok: false; error: string; unknown: boolean };

const UNKNOWN = "Не знаем, дошло ли замечание (нет связи или сервер не ответил). Нажмите «Отправить» ещё раз — дважды не запишется";
export async function sendFeedback(scope: FbScope, t: FbTarget, comment: string, requestId: string): Promise<SendResult> {
  const ac = new AbortController();
  const timer = window.setTimeout(() => ac.abort(), 20_000);   // зависший запрос не запирает окно
  try {
    const r = await api<{ ok: true; id: number }>("/api/uni-feedback", {
      method: "POST", retries: 0, signal: ac.signal,
      body: { pack: scope.pack, pack_version: scope.version, branch_id: scope.branchId, ...t, comment, request_id: requestId },
    });
    return { ok: true, id: r.id };
  } catch (e) {
    if (e instanceof ApiException && e.status < 500) return { ok: false, unknown: false, error: e.body?.error || `Ошибка ${e.status}` };
    return { ok: false, unknown: true, error: UNKNOWN };
  } finally { window.clearTimeout(timer); }
}

export const fetchFeedback = (scope: "mine" | "all") =>
  api<{ rows: FbRow[]; canAll: boolean }>(`/api/uni-feedback?scope=${scope}`, { retries: 0 });
export const setFeedbackStatus = (id: number, status: "new" | "done") =>
  api<{ ok: true; row: FbRow | null }>(`/api/uni-feedback/${id}`, { method: "PATCH", body: { status }, retries: 0 });
export const removeFeedback = (id: number) =>
  api<{ ok: true; already?: boolean }>(`/api/uni-feedback/${id}`, { method: "DELETE", retries: 0 });
